<template>
  <el-dialog title="选择电影(可输入关键词搜索)" :visible.sync="visible" width="700px" append-to-body>
    <div>
      <el-select v-model="movieId" clearable filterable placeholder="请选择电影">
        <el-option v-for="movie in list" :key="movie.id" :label="movie.title"
          :value="movie.id">
        </el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">确定选择</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import {
    getToken,
    setStorage,
    getStorage
  } from '@/utils/auth'
  export default {
    name: 'SelectMoviePopup',
    components: {},
    props: {
    },
    data() {
      return {
        visible: false,
        list: [],
        movieId: '',
        options: {}
      }
    },
    computed: {},
    mounted() {},
    methods: {
      parseOptions(options) {
        this.list = options.list || []
        this.options = options
        this.movieId = options.default
      },
      confirm () {
        this.options.success(this.movieId)
      }
    }
  }
</script>
<style lang="less" scoped>
  .container {
    background: white;
    border: 1px solid #e1e1e1;
    display: flex;
    width: 194px;
  }

  .title {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectMovie/listPopup.vue